module.exports = __webpack_public_path__ + "img/art_pic_01.273b0aa9.png";